import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react';

import SectionHeroFormationCarousel from './inc/SectionHeroFormationCarousel'

import '../assets/css/0010_sections/0420_section_content_formation.css'
import '../assets/css/0010_sections/0450_section_home_carrousel_tabs_formation.css'
// TODO SGU créer un composant unique Page_Brand et réunir ces sous-éléments

class PageBrand_CarrouselBanners extends Component {
	render() {
        const { scDatas } = this.props.fields.data;

		return (<>{scDatas?.ListContentForPage[0]?.ListFolderBanners[0]?.ListBanners && <>
            <SectionHeroFormationCarousel dataBanners={scDatas.ListContentForPage[0].ListFolderBanners[0].ListBanners}/>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(PageBrand_CarrouselBanners));